export default "__VITE_ASSET__79faa44d__"